import { combineReducers } from "@reduxjs/toolkit";
import products from "./productsSlice";
import cart from "./cartSlice";
import checkout from "./checkoutSlice";
import productCollections from "./productCollectionsSlice";
import wineClubs from "./wineClubsSlice";
import deliveryMethods from "./deliveryMethodsSlice";
import shippingCompliance from "./shippingComplianceSlice";
import events from "./eventsSlice";
import eventBooking from "./eventBookingSlice";
import lookups from "./lookupsSlice";
import store from "./storeSlice";
import order from "./orderSlice";
import orders from "./ordersSlice";
import invoice from "./invoiceSlice";
import address from "./addressSlice";
import paymentMethods from "./paymentMethodsSlice";
import tracking from "./trackingSlice";
import eventBookings from "./eventBookingsSlice";
import subscription from "./subscriptionSlice";
import subscriptionProducts from "./subscriptionProductsSlice";
import subscriptions from "./subscriptionsSlice";

const reducer = combineReducers({
  store,
  products,
  cart,
  checkout,
  productCollections,
  wineClubs,
  deliveryMethods,
  events,
  eventBooking,
  eventBookings,
  lookups,
  order,
  shippingCompliance,
  orders,
  address,
  paymentMethods,
  tracking,
  invoice,
  subscription,
  subscriptions,
  subscriptionProducts,
});

export default reducer;
